import * as React from 'react';

import { Input, } from '../../../Shared/index';

import { requestPut } from '../../../../modules/request/index';
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility';
import DemoGuardedButton from '../shared/demoGuardedButton';

interface ResetStudentPasswordModalProps {
  close: () => void;
  onSuccess: (string) => void;
  student: any;
  classroom: any;
}

const ResetStudentPasswordModal = ({ close, onSuccess, student, classroom }: ResetStudentPasswordModalProps) => {
  const { modalRef } = useModalAccessibility(close);

  function resetPassword() {
    const user = { password: student.name.split(' ')[1] }
    requestPut(`/teachers/classrooms/${classroom.id}/students/${student.id}`, { user, }, (body) => {
      onSuccess('Password reset')
      close()
    })
  }
  return (
    <div className="modal-container reset-student-password-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="resetStudentPasswordModalTitle"
        aria-modal="true"
        className="reset-student-password-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div>
          <h3 className="title" id="resetStudentPasswordModalTitle">Reset a student's password</h3>
        </div>
        <p>When you reset a student's password, the new password is the student's last name.</p>
        <Input
          className="password"
          disabled={true}
          id="new-password"
          label="New password"
          type="text"
          value={student.name.split(' ')[1]}
        />
        <div className="form-buttons">
          <button className="quill-button outlined grey medium focus-on-light" onClick={close} type="button">Cancel</button>
          <DemoGuardedButton className="quill-button contained red medium focus-on-light" onClick={resetPassword}>Reset Password</DemoGuardedButton>
        </div>
      </div>
    </div>
  )
}

export default ResetStudentPasswordModal
